import AddressFormatter from '@fragaria/address-formatter'

export const formatStreetAddress = ({
  countryCode,
  fallbackCountryCode = 'GB',
  premise,
  route,
  streetNumber,
}: {
  countryCode?: null | string
  /** Ordering to assume when the address has no country. Pass null to leave it unordered. */
  fallbackCountryCode?: null | string
  premise?: null | string
  route?: null | string
  streetNumber?: null | string
}) => {
  const commercial = premise?.trim() ?? ''
  const road = route?.trim() ?? ''
  const houseNumber = streetNumber?.trim() ?? ''
  if (!commercial && !road && !houseNumber) return ''

  const country = countryCode?.trim() || undefined
  const [line] = AddressFormatter.format(
    { commercial, countryCode: country, houseNumber, road },
    {
      appendCountry: false,
      fallbackCountryCode: fallbackCountryCode ?? undefined,
      output: 'array',
    },
  )

  return line === country ? '' : (line ?? '')
}
